<template>
  <v-container>

   <v-row>
      <v-col cols="12">
      <v-card elevation="1" v-if="profile">
        <v-card-title>
          {{profile.name}}
        </v-card-title>

        <v-card-subtitle>
          <span v-if="profile.role === 'teacher'">Учитель</span>
          <span v-if="profile.role === 'student'">Студент</span>
        </v-card-subtitle>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="12"
                  md="6"
              >
                <v-text-field
                    label="Имя" filled
                    readonly
                    v-model="profile.name"
                ></v-text-field>
              </v-col>

              <v-col
                  cols="12"
                  sm="12"
                  md="6"
              >
                <v-text-field
                    label="Электропочта" filled
                    readonly
                    v-model="profile.email"
                    :append-outer-icon="profile.email_verified === true ? 'mdi-email-check' : 'mdi-email-minus'"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card elevation="1" v-if="profile" color="blue darken-1" dark>
          <v-card-title>
            <span class="pr-2">Набранные баллы:</span>{{profile.score}}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
      <v-card elevation="1" v-if="profile" color="pink" dark>
        <v-card-title>
          Создано
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                  cols="12"
                  sm="4"
              >
                <v-card elevation="0" color="red darken-1">
                  <v-card-title>
                    Курсов
                  </v-card-title>
                  <v-card-text>
                    {{profile.summary.courses}}
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col
                  cols="12"
                  sm="4"
              >
                <v-card elevation="0" color="purple darken-1">
                  <v-card-title>
                    Тем
                  </v-card-title>
                  <v-card-text>
                    {{profile.summary.themes}}
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col
                  cols="12"
                  sm="4"
              >
                <v-card elevation="0" color="light-green darken-1">
                  <v-card-title>
                    Карточек
                  </v-card-title>
                  <v-card-text>
                    {{profile.summary.cards}}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {API} from "~/plugins/axios";

export default {
  name: "ProfileIndex",

  data: () => ({
    profile: undefined
  }),

  mounted() {
    this.fetchProfile()
  },

  methods: {
    fetchProfile() {
      let self = this
      API.get('user/profile').then((data) => {
        self.profile = data.data
      })
    },
  }
}
</script>
